export default __webpack_public_path__ + "static/media/correct1.1378e36f.mp3";